const constantUrls = {
  'About': "/about",
  'Checkout': "/donate",
  'Home': "/home",
  'Join': "/join-us",
  'Programs': "/programs",
}

const subsUrls = {
  // Sub About Links
  'Mission': `${constantUrls.About}/our-mission`,
  'Moral Leadership': `${constantUrls.About}/manuel`,
  'Partnership': `${constantUrls.About}/partnership`,
  'Contact': `${constantUrls.About}/contact`,
  'Faqs': `${constantUrls.About}/faqs`,
  'Foundation': `${constantUrls.About}/tedoi`,

  // Sub Programs Links
  'Lima': `${constantUrls.Programs}/lima`,
  'Piura': `${constantUrls.Programs}/piura`,
  'Huancavelica': `${constantUrls.Programs}/huancavelica`,
  'Huancayo': `${constantUrls.Programs}/huancayo`,
  'Costa': `${constantUrls.Programs}/costa`,
  'Puno': `${constantUrls.Programs}/puno`,
  'Selva': `${constantUrls.Programs}/selva`,
  'Sierra': `${constantUrls.Programs}/sierra`,
}

export const urls = {
  ...constantUrls,
  ...subsUrls
}

export const payments = ['25', '50', '100', '500', 'Other'];

export const recurringPeriods = ['Monthly', 'Quaterly (every 3 months)', 'Semi-Anually (every 6 months)', 'Yearly'];
